export const permissions = {
  defaultRedirectUrl: '/',
  defaultPermPrefix: 'gtcx_maps',
  routes: [['/', 'read:assets']]
};
export const appName = 'maps-frontend';

export const appVersion = '2.4.18';
export const pathDatePickerTimeLimit = 365; // days back from today
